'use strict';

angular.module('internal.services', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // services tab            
            .state('internal.licensing.service', {
                abstract: true,
                templateUrl: paths.app + 'services/components/service/service.html',
                controller: 'InternalService',
                params: {
                    id: null,
                    service: null
                }
            })
                .state('internal.licensing.service.investigations', {
                    url: '/service/:id/investigations',
                    templateUrl: paths.app + 'services/components/service-investigations/service-investigations.html',
                    controller: 'InternalServiceInvestigations',
                    params: {
                        id: null,
                        service: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.service.reimbursements', {
                    url: '/service/:id/reimbursements',
                    templateUrl: paths.app + 'services/components/service-training-reimbursements/service-training-reimbursements.html',
                    controller: 'InternalServiceTrainingReimbursements',
                    params: {
                        id: null,
                        service: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                    .state('internal.licensing.service.reimbursement', {
                        url: '/service/:id/reimbursement/:reimbursementID',
                        templateUrl: paths.app + 'services/components/service-training-reimbursement/service-training-reimbursement.html',
                        controller: 'InternalServiceTrainingReimbursement',
                        params: {
                            id: null,
                            service: null,
                            reimbursementID: null,
                            reimbursement: null
                        },
                        resolve: {
                            permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;

                                var method = 'view';
                                if ($stateParams.reimbursementID == null) {
                                    method = 'add';
                                }

                                return Permissions[method]('internal.licensing.service.reimbursements').then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                .state('internal.licensing.service.users', {
                        abstract: true,
                        templateUrl: paths.app + "services/layouts/service-users.html"
                    })
                    .state('internal.licensing.service.users.longevities', {
                        url: '/service/:id/longevities',
                        templateUrl: paths.app + 'services/components/service-users-longevities/service-users-longevities.html',
                        controller: 'InternalServiceUsersLongevities',
                        params: {
                            id: null,
                            service: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                        .state('internal.licensing.service.users.longevity', {
                            url: '/service/:id/longevity/:longevityID',
                            templateUrl: paths.app + 'services/components/service-users-longevity/service-users-longevity.html',
                            controller: 'InternalServiceUsersLongevity',
                            params: {
                                id: null,
                                service: null,
                                longevityID: null,
                                longevity: null
                            },
                            resolve: {
                                permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                                    $rootScope.$state.current = this.self;

                                    var method = 'view';
                                    if ($stateParams.longevityID == null) {
                                        method = 'add';
                                    }

                                    return Permissions[method]('internal.licensing.service.users.longevities').then(function (access) {
                                        if (!access) {
                                            $state.go('internal.licensing.denied');
                                        }
                                    });
                                }]
                            }
                        })
                .state('internal.licensing.service.history', {
                    url: '/service/:id/history',
                    templateUrl: paths.app + 'services/components/service-history/service-history.html',
                    controller: 'InternalServiceHistory',
                    params: {
                        id: null,
                        service: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.service.locations', {
                    abstract: true,
                    templateUrl: paths.app + "services/layouts/service-locations.html"
                })
                .state('internal.licensing.service.locations.history', {
                    url: '/service/:id/locationhistory',
                    templateUrl: paths.app + 'services/components/service-locations-history/service-locationhistory.html',
                    controller: 'InternalServiceLocationHistory',
                    params: {
                        id: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.service.clinicians', {
                    url: '/service/:id/clinicians',
                    templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                    controller: 'InternalClinicians',
                    params: {
                        id: null,
                        service: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internalNH.serviceDashboardPreview', {
                    url: '/service/:serviceId/previewDashboard/:previewUserId',
                    templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                    controller: 'InternalClinicians',
                    params: {
                        serviceId: null,
                        previewUserId: null,
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                            $rootScope.$state.current = this.self;
                            return PortalPermissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    //$state.go('portal.menus.denied');
                                }
                            });
                        }]
                    }
                })
            .state('internalNH.serviceDemographicsPreview', {
                url: '/service/:serviceId/previewDemographics/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null,
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
                .state('internalNH.servicePersonnelPreview', {
                    url: '/service/:serviceId/previewPersonnel/:previewUserId',
                    templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                    controller: 'InternalClinicians',
                    params: {
                        serviceId: null,
                        previewUserId: null,
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                            $rootScope.$state.current = this.self;
                            return PortalPermissions.view(this.self.name).then(function (access) {
                            });
                        }]
                    }
                })
                .state('internalNH.inspectionServicePreview', {
                    url: '/service/inspections/preview/:id',
                    templateUrl: paths.app + 'services/components/inspections-preview/inspections.html',
                    controller: 'PreviewServiceInspections',
                    params: {
                        id: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    //$state.go('portal.menus.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internalNH.organizationServicePreview', {
                    url: '/service/:serviceId/previewOrganization/:previewUserId',
                    templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                    controller: 'InternalClinicians',
                    params: {
                        serviceId: null,
                        previewUserId: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    //$state.go('portal.menus.denied');
                                }
                            });
                        }]
                    }
                })
            .state('internalNH.staffServicePreview', {
                url: '/service/:serviceId/previewStaff/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.serviceVehiclesPreview', {
                url: '/service/:serviceId/previewServiceVehicles/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null,
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.serviceVehicleDetailsPreview', {
                url: '/service/:serviceId/vehicle/:vehicleId/previewVehicleDetails/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null,
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.serviceDocumentsPreview', {
                url: '/service/:serviceId/previewDocuments/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null,
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.policiesServicePreview', {
                url: '/service/:serviceId/previewPolicies/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.policiesServiceDetailsPreview', {
                url: '/service/:serviceId/previewPolicies/:previewUserId/:policyId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null,
                    policyId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
            .state('internalNH.areasServicePreview', {
                url: '/service/:serviceId/previewAreas/:previewUserId',
                templateUrl: paths.app + 'services/components/clinicians/clinicians.html',
                controller: 'InternalClinicians',
                params: {
                    serviceId: null,
                    previewUserId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                        });
                    }]
                }
            })
    }])
;